import { Point } from '../Point'

export function distance(point: Point, point2: Point): number {
  const a = point.x - point2.x
  const b = point.y - point2.y

  return Math.sqrt(a * a + b * b)
}
